import { HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { environment } from '@env';
import { adAuthInterceptor } from '../interceptors/ad-auth.interceptor';
import { AuthenticationType } from '../models/authentication-type.enum';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);

  switch (environment.authenticationType) {
    case AuthenticationType.Anonymous:
      return next(req);
    case AuthenticationType.ActiveDirectory:
      return adAuthInterceptor(req, next);
    case AuthenticationType.AzureActiveDirectory:
    case AuthenticationType.AzureB2C:
      return injector.get(MsalInterceptor).intercept(req, { handle: next });
  }
};
